/* eslint-disable @typescript-eslint/prefer-optional-chain */
import React, { useMemo, useContext, useEffect } from 'react';
import classnames from 'classnames';
import { useRequest } from 'ahooks';
import { Table, TableColumn } from 'tea-component';
import { context as Context } from '@gp/components/Context';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import CardSlot from '@gp/components/CardSlot';
import DataTime from '@gp/components/DataTime';
import useTableSort from './hooks/useTableSort';
import useTableAddons from './hooks/useTableAddons';
import usePageLog from '@gp/hooks/usePageLog';
import { queryKeyIssuesOfManagement } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverallDetail';
import { getColumns, getLatestUpdateTimeOfKeyIssues } from './utils';

import './index.scss';

const StudioManagementKeyIssues: React.FC<IStudioManagementKeyIssueProps> = (props) => {
  const { style, className, ...remains } = props;

  const { studioId } = useContext<IStudioManagementContext>(Context);

  const {
    loading: isLoading,
    data: records,
    run: runQueryKeyIssuesOfManagement,
  } = useRequest(queryKeyIssuesOfManagement, { manual: true });

  const isHasData = !isLoading && records && records?.length > 0;
  const isNoData = !isLoading && (!records || !records?.length);

  const updateTime = getLatestUpdateTimeOfKeyIssues(records);

  const columns = useMemo<TableColumn<IStudioManagementKeyIssue>[]>(() => getColumns(), []);

  const { sortInfos, handleSortChange, sortedRecords } = useTableSort(records);

  const { addons } = useTableAddons({
    sortInfos,
    onSortChange: handleSortChange,
  });

  useEffect(() => {
    if (!studioId) return;
    runQueryKeyIssuesOfManagement({ studio_id: studioId });
  }, [studioId]);

  usePageLog({
    pageId: 'STUDIO_OVERALL_DETAILS_MANAGEMENT_KEY_ISSUES',
    uidType: 'studio_id',
    uid: studioId || '',
  });

  return (
    <CardSlot
      {...remains}
      style={style}
      className={classnames('dbg-studio-management-key-issues-card', className, {
        'no-horizontal-padding': isHasData,
        'no-bottom-padding': isHasData,
      })}
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          Key Issues
          {!!updateTime && <DataTime style={{ marginLeft: 6 }} dateType="Month" date={updateTime} />}
        </div>
      }
    >
      {/* 加载动画 */}
      {isLoading && <Loading loading style={{ height: 350 }} />}
      {/* 无数据 */}
      {isNoData && <NoData height={262} constomStyle={{ fontSize: 14 }} />}
      {/* Key Issues表格 */}
      {isHasData && (
        <Table
          className="dbg-common-table dbg-common-table-compact dbg-studio-management-key-issues-table"
          recordKey="category"
          addons={addons}
          columns={columns}
          records={sortedRecords}
        />
      )}
    </CardSlot>
  );
};

export default React.memo(StudioManagementKeyIssues);
